export default __webpack_public_path__ + "static/media/kobe-ad.0213ddce.jpg";